import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import { GetSsoToken } from '../components/Session';
import { useAuthDataContext } from "../components/AuthDataProvider";
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';



export default function Auth() {
  const { onLogin } = useAuthDataContext();

  const [redirectURL, setRedirectURL] = useState(null)
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
      const code = searchParams.get('code')
      if(code){
          GetSsoToken(code)
              .then((result) => {
                      onLogin(result)
                      setRedirectURL("/water")
                  }
              ).catch((error) => {
                  setRedirectURL("/login")
              }
          )}
  }, [searchParams]);

  if (redirectURL) {
    window.location.assign(redirectURL)
  }

  return (
      <Container maxWidth="lg" className="container">
        <br />
        <Paper spacing={3}>

          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '25vh' }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <h1>Login</h1>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                  <CircularProgress size={48} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    )
}
